import React from "react";
import {
  Card,
  ImageWrapper,
  Image,
  Tag,
  Content,
  PlayerName,
  Meta,
  Bold,
  Stats,
  Cups,
  CupIcon,
  CupsText,
} from "./FavouriteReportsCard.style";
import NFLAnalysis from "../../assets/img/NFLAnalysis.png";
import Cup from "../../assets/img/Cup.png";
import { useNavigate } from "react-router-dom";

const FavouriteReportsCard = ({
  imageUrl,
  tag,
  school,
  position,
  goals,
  assists,
  minutes,
  cups,
  playerName,
  id,
}) => {
  const navigate = useNavigate();
  return (
    <Card onClick={() => navigate(`/scouting-reports/${id}`)}>
      <div style={{ position: "relative" }}>
        <ImageWrapper>
          <Image src={imageUrl} alt="helmet" />
          <Tag>Player Name</Tag>
        </ImageWrapper>
        <img
          src={NFLAnalysis}
          alt="helmet"
          style={{
            position: "absolute",
            bottom: "3px",
            left: "0px",
            width: "100px",
            height: "100px",
            borderRadius: "5px",
            objectFit: "contain",
          }}
        />
      </div>
      <Content>
        <PlayerName>{playerName}</PlayerName>
        <Meta>
          <div style={{ display: "flex", gap: "4px", marginBottom: "25px" }}>
            <p style={{ color: "#444", fontSize: "12px" }}>School:</p>{" "}
            <Bold>{school}</Bold>{" "}
            <p style={{ color: "#444", fontSize: "12px" }}>Position:</p>{" "}
            <Bold>{position}</Bold>
          </div>
        </Meta>
        <Stats>
          <div style={{marginBottom:"8px"}}>
            <Bold>
              <span style={{ display: "flex", gap: "4px" }}>
                Goals scored:{" "}
                <p style={{ color: "#444", fontSize: "12px" }}>
                  {goals} (verified)
                </p>
              </span>
            </Bold>
          </div>
          <div style={{marginBottom:"8px"}}>
            <Bold>
              <span style={{ display: "flex", gap: "4px" }}>
                Assists:{" "}
                <p style={{ color: "#444", fontSize: "12px" }}>
                  {assists} (verified){" "}
                </p>
              </span>
            </Bold>
          </div>
          <div style={{marginBottom:""}}>
            <Bold>
              <span style={{ display: "flex", gap: "4px" }}>
                Minutes played:{" "}
                <p style={{ color: "#444", fontSize: "12px" }}>{minutes}</p>
              </span>
            </Bold>
          </div>
        </Stats>
        <Cups>
          {Array.from({ length: cups }).map((_, i) => (
            // <CupIcon key={i}>🏆</CupIcon>
            <img key={i} src={Cup} alt="cup" style={{width:"15px", height:"15px", marginRight:"2px"}} />
          ))}
          <CupsText>{cups} Cups</CupsText>
        </Cups>
      </Content>
    </Card>
  );
};

export default FavouriteReportsCard;
